import script from "./detail.vue?vue&type=script&lang=ts&setup=true"
export * from "./detail.vue?vue&type=script&lang=ts&setup=true"

import "./detail.vue?vue&type=style&index=0&id=38be637b&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38be637b"]])

export default __exports__